<template>
	<el-form ref="fixRateForm" :model="detailFrom" :rules="rules">
		<div v-for="(item, index) in detailFrom.detail" :key="index" class="a-felx-cfsfs a-mt-10 projectadd-box">
			<div class="a-flex-rfsc">
				<le-company-underandparent-select 
                    :label="'收益方' + (index + 1)" 
                    v-model="item.targetCompanyInfo" 
                    isObj
                    large>
                </le-company-underandparent-select>
                <el-tag class="a-ml-10" v-for="(ite,index) in item.targetCompanyInfo.payPlatform" :key="index">{{ util.initDic(ite.servicePlatform, 'servicePlatform') }}</el-tag>
                <!-- <div class="a-flex-rfsc a-fs-14 a-ml-15" style="cursor: pointer;" @click="handleSetPayCompany(item)">
                    <i class="el-icon-success a-fs-16" :class="item.payCompany?'a-c-blue':'a-c-second'" ></i>
                    <span class="a-c-normal a-ml-5">设为收款商户</span>
                </div> -->
                <!-- <el-checkbox v-model="item.payCompany" class="a-ml-15">设为收款商户</el-checkbox> -->
				<i class="el-icon-remove-outline a-c-red a-fs-16 a-ml-15" v-if="index > 0 && !item.notDel" @click="handlerDelFixedIncome(index)"></i>
			</div>
            <div class="a-flex-rfsfs" v-if="company.isSystem && (userInfo.dataPermission == 99)">
				<!-- <le-company-underandparent-select 
                    label="上级商户" 
                    v-model="item.showCompanyId" large>
                </le-company-underandparent-select> -->
                <le-select-local-search 
                    label="上级商户" 
                    large
                    v-model="item.showCompanyId" 
                    :options="showCompanyOptions" />
			</div>
			<el-form-item :prop="'detail.' + index + '.rate'" :rules="{ validator: validateDetail, trigger: 'change' }">
				<div class="a-flex-rfsc">
					<span style="width: 140px; margin-top: 4px">分成比例</span>
					<el-input placeholder="请输入分成比例" type="number" min="0" v-model="item.rate" large
						style="width: 376px !important" :max="maxRate">
						<template slot="append">%</template>
					</el-input>
				</div>
			</el-form-item>
		</div>
		<div class="a-flex-rfsc a-mt-10 addFixedIncom font-point" @click="handlerAddFixedIncome">
			<i class="el-icon-circle-plus-outline a-c-blue a-fs-16"></i>
			<span class="a-ml-03 a-c-blue">添加</span>
		</div>
	</el-form>
</template>

<script>
    import util from "../../utils/util.js";
	import {
		mapState,
		mapActions
	} from 'vuex';
	export default {
		props: {
			value:{
				type:Array
			},
			incomeId: {
				type: Number,
			},
			maxRate: {
				type: Number
			},
			ownerCompanyId: {
				type: Number
			}
		},
		computed: {
			...mapState({
				company: state => state.company.company,
                userInfo: state => state.user.user,
			})
		},
		data() {
			return {
                util,
				detailFrom:{
					detail: [],
				},
				ownerRate:0,//本商户收益
				rules: {},
                fZTemplateOptions: {
                    url: this.$Config.apiUrl.getIncomePlanList,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "planName",
                    valueKey: "id",
                    searchKey: "planName",
                },
                showCompanyOptions: [{
                    label: '上海玖电科技有限公司',
                    value: 2
                }]
			}
		},
		watch: {
			value:{
				handler(val) {
					if (val) {
						this.detailFrom.detail = val
					}
				},
				deep:true,
				immediate:true
			},
			incomeId: {
				handler(val) {
					if (val) {
						this.getIncomeDetail();
					}
				}
			},
			maxRate: {
				handler(val) {
					this.setDefaultRate()
				}
			},
			ownerCompanyId:{
				handler(val) {
					this.setDefaultRate()
				}
			},
			'detailFrom.detail':{
				handler(val) {
					this.$emit('input',val)
				},
				deep:true,
			},
		},
		methods: {
			/**
			 * 设置默认收益比例
			 */
			setDefaultRate() {
				if (this.maxRate && this.ownerCompanyId && this.detailFrom.detail.length == 0) {
					this.detailFrom.detail.push({
						targetCompanyId: this.company.id,
						showCompanyId: '',
						rate: this.maxRate,
						testRunRate: null,
						serNo:0,
                        incomePlanId: '1',
						rangeDetail:[],
                        payCompany: 1,
                        targetCompanyInfo: {
                            label: this.company.name,
                            value: this.company.id,
                            payPlatform: this.company.payPlatform,
                        },
					})
				}
			},
			/**
			 * 获取项目详情
			 */
			getIncomeDetail() {
				this.$Axios._get({
						url: this.$Config.apiUrl.gitEditIncomeDetailInfo,
						params: {
							incomeId: this.incomeId,
						},
					})
					.then(({
						data
					}) => {
						this.detailFrom.detail = data.targetList.map(item => {
							return {
								targetCompanyId: item.targetCompanyId,
                                showCompanyId: item.showCompanyId != 2 ? '' : item.showCompanyId,
                                payCompany: item.payCompany ? item.payCompany : 0,
								rate: item.rate / 100,
								testRunRate: null,
								serNo:item.serNo,
                                incomePlanId: item.incomePlanId,
								rangeDetail:[],
                                targetCompanyInfo: {
                                    label: item.targetCompanyName,
                                    value: item.targetCompanyId,
                                    payPlatform: item.payPlatform,
                                }
							}
						})
					});
			},
			/**
			 * 添加固定收益条目
			 */
			handlerAddFixedIncome() {
				/**
				 * 计算最大序号条目
				 */
				let maxSerNo = 0
				this.detailFrom.detail.map(item=>{
					if(item.serNo>=maxSerNo){
						maxSerNo = item.serNo
					}
				})
				let rateDetai = {
					targetCompanyId: null,
                    showCompanyId: null,
					rate: 0,
					testRunRate: null,
					serNo:maxSerNo+1,
                    incomePlanId: "1",
					rangeDetail:[],
                    payCompany: 0,
                    targetCompanyInfo: '',
				};
				this.detailFrom.detail.push(rateDetai);

                // this.detailFrom.detail.map(item=>{
				// 	this.$set(item, 'payCompany', 0)
				// })
			},
			
			handlerDelFixedIncome(index){
				this.detailFrom.detail.splice(index,1)

                // if(this.detailFrom.detail.length <= 1) {
				// 	this.$set(this.detailFrom.detail[0], 'payCompany', 1)
				// }
                let payCompanyInfo = this.detailFrom.detail.find(res=>{
					return res.payCompany == 1
				})
				if(!payCompanyInfo) {
					this.$set(this.detailFrom.detail[0], 'payCompany', 1)
				}
			},

            handleSetPayCompany (datas) {
                let targetCompanyId = datas.targetCompanyId || datas.targetCompanyInfo.value
                if(!targetCompanyId) {
                    this.$message.error('请先选择收益方')
                    return
                }
                this.detailFrom.detail.map(item=>{
                    if(item.targetCompanyId == targetCompanyId || item.targetCompanyInfo.value == targetCompanyId) {
                        this.$set(item, 'payCompany', 1)
                    }else {
                        this.$set(item, 'payCompany', 0)
                    }
                })
            },
			
			/**
			 * form校验
			 * @param {Object} rule
			 * @param {Object} value
			 * @param {Object} callback
			 */
			validateDetail(rule, value, callback) {
				let index = rule.field.split(".")[1];
				let _value = this.detailFrom.detail[index].rate
				if(!(_value+'').match(/^\d{1,3}(\.\d{1,2})?$/)){
					return callback(new Error("请输入正确数值,最大"+this.maxRate+",最小0,小数点后最多2位"));
				}
				if(_value>this.maxRate || _value<0){
					return callback(new Error("请输入正确数值,最大"+this.maxRate+",最小0,小数点后最多2位"));
				}
				
				/**
				 * 过滤获取本商户收益
				 */
				this.ownerRate = this.detailFrom.detail.map((item, index) => {
					if(item.targetCompanyInfo.value == this.company.id){
						return item.rate ? item.rate : 0; 
					}else{
						return 0;
					}
				}).reduce(function(prev, cur) {
					return Number(prev) + Number(cur);
				});
				let totalRate = 0
				this.detailFrom.detail.map(item=>{
					totalRate += Number(item.rate || 0)
				})
				
				if (!this.ownerCompanyId) {
					return callback(new Error("请选择所属商户"));
				} else if (!this.detailFrom.detail[index].targetCompanyInfo) {
					return callback(new Error("请选择对应的收益方"));
				} else if (totalRate > this.maxRate) {
					return callback(new Error("设置的分成总比例"+totalRate+"%不能超过最大可分配比例"+this.maxRate+'%'));
				} else if (!this.detailFrom.detail[index].incomePlanId) {
					return callback(new Error('请选择收益方分账模板'));
				} else {
					return callback();
				}
			},
		}
	}
</script>

<style>
</style>